module.exports = __webpack_public_path__ + "media/images/realizacje/real1-6f40d27083adec03f39e92e3b96488d9.png";